import { useState, useEffect, useContext } from 'react';
import { useApolloClient } from '@apollo/client';
import { getGroupListsQuery } from "../../../graphql/groups_queries";
import { GlobalContext } from "../../../hooks/globalContext";
import apiCall from '../../../utility/api';




const Monitors_func = (props: any) => {

	const [alertVariable, setAlertVariable] = useState()
	const client = useApolloClient();
	const contextValue: any = useContext(GlobalContext);
	var tenantName = contextValue.tenantName;

	const getGroupsList = async (whereCondition: object, limit: number | null, offset: number | null) => {
		try {
			// await groupsAttachedToMonitor({ types: props.automationType, automationName: props.automationName, dartid: props.dartNo });
			const { status, data } = await apiCall('/groups/getList', { ...whereCondition, limit, offset });
			if (status === 'success' && data?.length > 0) {
				await getTenantDevicesCnt({ tenant: props.tenant });
				data.map(async (val: any) => {
					await getGroupedDeviceCnt({ tenant: props.tenant, classification: val.classificationName }, val.classificationName);
				});
				props.func(data);
			} else {
				props.func([]);
			}
		} catch (error) {
			console.log("getGroupsList error=", error);
			props.func([]);
		}
	};

	const getExportData = async (condition: object) => {
		try {
			const { status, data } = await apiCall(`/groups/getList`, condition);

			if (status === 'success') {
				props.setExportDetails && props.setExportDetails(data);
			}

			setTimeout(() => {
				props.setExportBtnClicked(false);
			}, 2000);
		} catch (error) {
			console.log("remediation assignment getExportData error=", error);
			props.setExportBtnClicked(false);
		}

	}


	const getTenantDevicesCnt = async (whereCondition: object) => {
		try {
			const { status, data } = await apiCall('/census/getCensusCount', whereCondition);
			if (status === 'success' && data?.totalRecords > 0) {
				props.setDeviceCnt(data.totalRecords);
			} else {
				props.setDeviceCnt(0);
			}
		} catch (error) {
			console.log("getCensusListsCnt error=", error);
			props.setDeviceCnt(0);
		}
	}

	const getGroupedDeviceCnt = async (whereCondition: any, name: string) => {
		try {
			const { status, data } = await apiCall(`/groups/getDeviceCount`, whereCondition);
			if (status === 'success' && data?.length > 0) {
				props.setGroupDeviceCnt((prev: any) => ({
					...prev,
					[`${name}`]: data?.length,
				}));
			} else {
				props.setGroupDeviceCnt((prev: any) => ({
					...prev,
					[`${name}`]: 0,
				}));
			}
		} catch (error) {
			console.log("getGroupedDevicesCnt error=", error);
			props.setGroupDeviceCnt((prev: any) => ({
				...prev,
				[`${name}`]: 0,
			}));
		}
	}

	const getGroupsListCnt = async (whereCondition: any, setTotalRecords: any, setTotalPages: any) => {
		try {
			const { data, status } = await apiCall(`/groups/getCount`, whereCondition);
	
			if (status === 'success' && data) {
				console.log("count data",data);
				setTotalRecords(data.totalRecords);
				setTotalPages(data.totalPages);
			} else {
				setTotalRecords(0);
				setTotalPages(1);
			}
		} catch (error) {
			console.log("getGroupsListCnt error=", error);
			setTotalRecords(0);
			setTotalPages(1);
		}
	};




	const saveAlertQuery = () => {
		//if the selected groups is ALLdevices get the query already stored in the db and send the same to scope
		let id: any = props.alertId;
		id = parseInt(id)
		// getAlertVariableDetails(id)
		if (alertVariable) {
			saveQueryToScope(id, alertVariable)
		}
	}

	const saveQueryToScope = async (id: number, variableQueryData: String) => {
		try {
			const groupsSelected = contextValue.selectedRowIdInTable
			const { data } = await apiCall('/monitors/getAlertVariable', { id })
			if (data) {
				// getting all the tenantsObjects from group_include
				props.setProgressLoading(true)
				const tenantObjects = data?.groups ? JSON.parse(data?.groups) : []
				// getting and setting the present tenant object with its groups
				const currentTenantObject = tenantObjects.length > 0 ? tenantObjects?.filter((obj: object) => Object.values(obj).includes(tenantName)).length > 0 ? tenantObjects?.filter((obj: object) => Object.values(obj).includes(tenantName)) : [{}] : [{}] //presentGroup
				// if the Tenant doesn't exisits then create new object
				const alertName = data?.alertName
				console.log("id",id,"variableQueryData", variableQueryData,"currentTenantObject", currentTenantObject,"tenantObjects", tenantObjects,"groupsSelected", groupsSelected,"tenantName", tenantName,"alertName", alertName)
				const { status, dataInput } = await apiCall('/monitors/saveQueryToScope', { id, variableQueryData, currentTenantObject, tenantObjects, groupsSelected, tenantName, alertName })
				if (dataInput != null) {
					if (status == "success") {
						getAlertVariableDetails(id)
						props.setProgressLoading(false)
						props?.setToastMessage("Alerts Attachment Successful")
						props?.setMessagebar3(true)
					} else if (status == "failure") {
						props.setProgressLoading(false)
						props?.setToastMessage("Alerts attachment Failed!")
						props?.setErrorToast(true)
					}
				}
			}
		} catch (error) {
			console.log(" saveQueryToScope error: ", error)
			console.error(
				"An unexpected error occurred:  ALERT UPDATE",
				(error as Error).message
			);
			props.setProgressLoading(false)
			props?.setToastMessage("Alerts attachment Failed!")
		}
	}

	const getAlertVariableDetails = async (id: any) => {
		try {
			let groupsIncludedArray: any = []
			const { status, data } = await apiCall('/monitors/getAlertVariable', { id })
			if (status === "success" && data != undefined) {
				// getting all the tenantsObjects from group_include
				const tenantObjects = data?.groups ? JSON.parse(data?.groups) : []
				// getting and setting the present tenant object with its groups
				const tenantGroups = tenantObjects.length > 0 ? tenantObjects?.filter((obj: object) => Object.values(obj).includes(tenantName)) : []
				groupsIncludedArray = tenantGroups.length > 0 ? Object.values(tenantGroups[0].GroupsAttached) : []
				setAlertVariable(data?.variable)
				props.setPreviousSelectedGroups(groupsIncludedArray)
			}
		} catch (error) {
			console.error("An unexpected error occurred in alertvariableQuery:", (error as Error).message);
		}
	}

	useEffect(() => {
		var id = props.alertId;
		id = parseInt(id)
		getAlertVariableDetails(id)
		// props.setPreviousSelectedGroups(groupsInclude)
	}, [])

	useEffect(() => {

		if (props.saveBtnClicked == true) {
			saveAlertQuery()
		}
		if (props.searchVal?.length > 0 && props.searchVal !== '') {
			getGroupsList({ tenant: props.tenant, function: 'search', search: props.searchVal }, 50, props.pageNo);
			getGroupsListCnt({ tenant: props.tenant, function: 'search', search: props.searchVal }, props.setTotalRecords, props.setTotalPages);
		} else if (props.isRefresh) {
			props.setRefresh(false);
			getGroupsList({ isGroupConfigured: { _eq: "Yes" }, mgroupuniq: { _is_null: false }, tenant: { _eq: tenantName } }, 50, props.pageNo);
			getGroupsListCnt({ isGroupConfigured: { _eq: "Yes" }, mgroupuniq: { _is_null: false }, tenant: { _eq: tenantName } }, null, 0);
			props.setRefreshToast(true);
			setTimeout(() => {
				props.setRefreshToast(false);
			}, 3000);
		} else if (props.exportBtnClicked) {
			getExportData({ function: 'export', tenant: props.tenant });
		} else {
			getGroupsList({ tenant: props.tenant }, 50, props.pageNo);
			getGroupsListCnt({ tenant: props.tenant }, props.setTotalRecords, props.setTotalPages);
		}
	}, [props.exportBtnClicked, props.isRefresh, props.searchVal, props.saveBtnClicked, props.pageNo, props.policyPatch, props.alertId, alertVariable]);

	return (
		<></>
	)
}

export { Monitors_func }


